<template>
    <canvas :height="chartHeight"></canvas>
</template>

<script>
    import Chart from 'chart.js';
    import PieceLabel from './../../plugins/PieceLabel';
    import ChartMixin from './../../mixins/chart';

    export default {
        data() {
            return {
                chart: {},
                hasAnimated: false,
                graphType: 'podium',
            }
        },

        mixins: [ChartMixin],

        props: {
            title: {
                type: String,
            },

            type: {
                type: String,
                default: 'bar',
            },

            labels: {
                required: true,
                type: Array,
            },

            datasets: {
                required: true,
                type: Array,
            },

            height: {
                type: Number,
            },
        },

        watch: {
            datasets() {
                this.redraw();
            }
        },

        mounted() {
            bus.$on('update-charts', function () {
                this.redraw();
            }.bind(this));

            this.draw();
        },

        computed: {
            chartHeight() {
                if (typeof this.height == 'undefined') return '';

                return this.height;
            },
        },

        methods: {
            draw() {
                let self = this;

                this.chart = new Chart(this.$el.getContext('2d'), {
                    type: 'bar',
                    data: {
                        labels: this.labels,
                        datasets: this.datasets,
                    },
                    options: {
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            enabled: false,
                        },
                        legend: {
                            display: false,
                        },
                        pieceLabel: {
                            // mode 'label', 'value' or 'percentage', default is 'percentage'
                            mode: 'value',

                            // precision for percentage, default is 0
                            precision: 0,

                            // font size, default is defaultFontSize
                            fontSize: 20,

                            // font color, default is '#fff'
                            fontColor: '#fff',

                            // font style, default is defaultFontStyle
                            fontStyle: 'normal',

                            // font family, default is defaultFontFamily
                            fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

                            // draw text in arc, default is false
                            arcText: true,

                            // draw text on the border, default is false
                            borderText: true,

                            // format text, work when mode is 'value'
                            format: function (value) {
                                return 6 - value;
                            }
                        },
                        scales: {
                            yAxes: [{
                                display: false,

                                afterFit: function (scaleInstance) {
                                    scaleInstance.width = 0;
                                }.bind(this),

                                ticks: {
                                    beginAtZero: true,
                                },

                                gridLines: {
                                    display: false,
                                }
                            }],

                            xAxes: [{
                                barPercentage: 0.99,
                                categoryPercentage: 0.99,
                                gridLines: {
                                    display: false,
                                },
                                afterFit: function (scaleInstance) {
                                    scaleInstance.height = 96;
                                }.bind(this),
                            }],
                        },
                        maintainAspectRatio: false,
                    }
                })

                _.defer(() => {
                    this.getAsImage();
                })
            },
        }
    }
</script>